import { createContext, Dispatch, SetStateAction, useContext } from 'react';
import { INotification } from '@vivli/shared/features/notification/infrastructure/interface';
import { NotificationTopicEnum } from '@vivli/shared/features/notification/infrastructure/enum';
import { UseFormReturn } from 'react-hook-form';

interface INotificationContext {
    getNotifications?: (topicId) => void;
    notifications?: INotification[];
    firstAndLastDates?: string[];
    resetNotificationForm?: () => void;
    handleSubmit?: (topicType: NotificationTopicEnum) => void;
    showForm?: boolean;
    lastSentMessageState?: string;
    isSaving?: boolean;
    formApi?: UseFormReturn<INotification>;
    setFormApi: Dispatch<SetStateAction<UseFormReturn<INotification>>>;
    isFormValid?: boolean;
    isFormDirty?: boolean;
}

export const NotificationContext = createContext<INotificationContext>(null);

export const useNotificationContext = () => useContext(NotificationContext);
